import React from 'react';
import axios from 'axios';
import axiosConfig from '../../config/axios.config';
import {InstanceContext} from "../../InstanceContext";
import styles from './styles'
import { Button } from '@xpertdox_js/xdcomponents';

const UserLogs = (props) => {
  const callControl = React.useRef(false)
  const [logs, setLogs] = React.useState(false);
  const {contextInstance} = React.useContext(InstanceContext)
  const trialInstance = contextInstance || props.user.instance;

  if(!logs && !callControl.current) {
    callControl.current = true;
    axios.get(`${axiosConfig.apiUrl}/rt/console/getUserLogs/${trialInstance}/${props.user.email}`).then(lgs => {
      console.log(lgs)
      setLogs(lgs.data);
    }).catch(err => console.log(err))
  }

  const downloadCSV = () => {

  }

  const renderLog = (log, i) => {
    const mapp = (tag) => {
      let tags = {
        'ts_include': 'Treatment Status Inclusion Criteria',
        'ts_exclude': 'Treatment Status Exclusion Criteria',
        'ds_exclude': 'Disease Stage Exclusion Criteria',
        'ds_include': 'Disease Stage Inclusion Criteria',
        'mutationsIN': 'Eligible Mutations',
        'mutationsOUT': 'Ineligible Mutations',
        'display': 'Display',
        'gender': 'Gender',
        'startDate': 'Start Date',
        'endDate': 'End Date'
      }
      if(tags[tag]) return tags[tag]
      else return tag
    }

    const parseData = (data) => {
      let keys = Object.keys(data);
      let parsed = keys.map(key => {
        if(typeof data[key] === 'string') return {key: mapp(key), data: data[key]}
        else if (Array.isArray(data[key])) return {key: mapp(key), data: data[key].join(', ')}
        else {
          let value = '',
            selected = '';
          let subKeys = Object.keys(data[key]);
          subKeys.forEach(subKey => {
            if(typeof data[key][subKey] === 'object') {
              console.log(data[key][subKey])
              let subSubKeys = Object.keys(data[key][subKey]);
              subSubKeys.forEach(subSubKey => {
                if (Array.isArray(data[key][subKey][subSubKey])) {
                  value = `${mapp(key)} => ${subKey} => ${subSubKey}`;
                  selected = data[key][subKey][subSubKey].join(', ')
                }
              })
            } else if (Array.isArray(data[key][subKey])) {
              value = `${mapp(key)} => ${subKey}`;
              selected = data[key][subKey].join(', ')
            }
          })
          return {key: value, data: selected}
        }
      })

      return <ul>
        {parsed.map((p, i) => <li>{p.key}{p.data && p.data !== '' ? ': '+p.data : ''}</li>)}
      </ul>
    }

    return <div key={i}>
      <p><b>{i+1}.</b> {log.created_date}: {log.type}</p>
      {log.data ? parseData(log.data) : ''}
    </div>
  }


  return <div style={styles.logContainer}>
    <div style={styles.logScroll}>
      {/*<Button onClick={downloadCSV} styles={styles.download}>Download CSV</Button>*/}
      {Object.keys(logs).map((trial, index) => <div style={{fontSize: 13, paddingTop: 2}}>
        <h4>{trial}</h4>
        {logs[trial].map((log, i) => renderLog(log, i))}
      </div>)}
    </div>

  </div>
}

export default UserLogs;
